import React, { useEffect, useRef, useState } from "react"
import { FaSearch } from "react-icons/fa"

import { Input } from "components"
import classes from "./LsSearch.module.scss"

const LsSearch = props => {
  const { onSearch, placeholder, delay } = props

  const [search, setSearch] = useState("")

  const timeout = useRef()

  const handleChange = (e) => {
    clearTimeout(timeout.current)

    const value = e.target.value

    setSearch(value)

    timeout.current =
      setTimeout(() => {
        onSearch(value.trim())
      }, delay)
  }

  useEffect(() => {
    return () => {
      clearTimeout(timeout.current)
    }
  }, [])

  return (
    <div className={classes["container"]}>
      <FaSearch />

      <Input
        value={search}
        className={classes["input"]}
        placeholder={placeholder}
        onChange={handleChange}
      />
    </div>
  )
}

export default LsSearch